import React, { useEffect, useState } from 'react';
import Nav from '../../../components/Nav/Nav';
import Footer from '../../../components/Footer/Footer';
import Profile from './Profile/Profile';
import Tetromino from './Tetromino/Tetromino';
import Assets from './Assets/Assets';
import styles from './Dashboard.module.css';
import Divider from '../../../components/Divider/Divider';
import TeamProfile from './Profile/TeamProfile';
import useStore from '../../../hooks/useStore';

const Dashboard = () => {
    const { isTeamUser, checkTeamUserStatus, address } = useStore();
    const [activeTab, setActiveTab] = useState('referral');
    
    useEffect(() => {
        if (address) {
            checkTeamUserStatus();
        }
    }, [address, checkTeamUserStatus]);

    return (
        <div className={styles.dashboardContainer}>
            <Nav />
            <main className={styles.mainContent}>
                <div className={styles.container}>
                    {/* Tabs Menu */}
                    <div className={styles.tabsMenu}>
                        <button 
                            className={`${styles.tabButton} ${activeTab === 'referral' ? styles.activeTab : ''}`}
                            onClick={() => setActiveTab('referral')}
                        >
                            Referral
                        </button>
                        <button 
                            className={`${styles.tabButton} ${activeTab === 'wallet' ? styles.activeTab : ''}`}
                            onClick={() => setActiveTab('wallet')}
                        >
                            Wallet
                        </button>
                    </div>
                    
                    {/* Tab Content */}
                    <div className={styles.tabContent}>
                        {activeTab === 'referral' && (
                            <>
                                <Profile />
                                <div className={styles.tetrominoContainer}>
                                    <Tetromino />
                                </div>
                                {isTeamUser && <TeamProfile />}
                            </>
                        )}
                        
                        {activeTab === 'wallet' && (
                            <Assets address={address} />
                        )}
                    </div>
                </div>
            </main>
            <Divider />
            <Footer />
            <Divider />
        </div>
    );
};

export default Dashboard;
